<template>
  <div class="main">
    <div class="nav">
       <van-nav-bar
        title="预约体检"
        left-arrow
        :fixed=true
        @click-left="onClickLeft"
      />
    </div>
    <div class="body">
      <!-- <div class="title">
       基本信息
     </div> -->
    <van-form>
        <van-field
       v-model="pickerValue.TJLX"
        readonly
        required
        disabled
        size="large"
        label="体检类型"
      />
       <van-field
        readonly
        required
        clickable
        :value="form['ordertime']"
        label="预约时间"
        placeholder="点击选择预约时间"
        @click="showPicker['ordertime'] = true"
        :rules="[{ required: true, message: '该选项不能为空' }]"
      />
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="pickerValue['profession']"
        label="职业"
        placeholder="点击选择职业"
        @click="showPicker['profession'] = true"
         :rules="[{ required: true, message: '该选项不能为空' }]"
      />
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="pickerValue['nation']"
        label="民族"
        placeholder="点击选择民族"
        @click="showPicker['nation'] = true"
         :rules="[{ required: true, message: '该选项不能为空' }]"
      />
       <van-field
        readonly
        required
        clickable
        name="picker"
        :value="pickerValue['marriage']"
        label="婚姻"
        placeholder="点击选择状态"
        @click="showPicker['marriage'] = true"
          :rules="[{ required: true, message: '该选项不能为空' }]"
      />
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="pickerValue['blood']"
        label="血型"
        placeholder="点击选择血型"
        @click="showPicker['blood'] = true"
       :rules="[{ required: true, message: '该选项不能为空' }]"
      />
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="pickerValue['petype']"
        label="体检类型"
        placeholder="点击选择体检类型"
        @click="showPicker['petype'] = true"
       :rules="[{ required: true, message: '该选项不能为空' }]"
      />
       <van-field
        readonly
        required
        clickable
        name="picker"
        :value="pickerValue['obtype']"
        label="职业体检类型"
        placeholder="非职业体检不填"
        @click="isobtype?null:showPicker['obtype'] = true"
        :disabled="isobtype?true:false"
       :rules="[{ required:true, message: '该选项不能为空' }]"
      />
        <van-field
        v-model="form.phoneNumber"
        size="large"
        label="手机号码"
        :placeholder="form['phoneNumber']"
        disabled
      />
       <van-field
        readonly
        disabled
        size="large"
        label="就诊卡号"
        :value="form['personalNo']"
      />
      <van-field
        readonly
        disabled
        size="large"
        label="姓名"
        :value="form['name']"
      />
    
      <van-field
        readonly
        disabled
        size="large"
        label="身份证号"
        :value="form['idcard']"
        placeholder="选择证件类型"
      />
      <van-field
        readonly
        disabled
        size="large"
        label="生日"
        :value="form['birthday']"
        placeholder=""
      />
      <van-field
        readonly
        disabled
        size="large"
        label="性别"
        :value="form['gender']"
        placeholder=""
      />
      <van-popup v-model="showPicker['nation']" position="bottom">
        <van-picker
          show-toolbar
          :columns="NationColumns"
          value-key="name"
          @confirm="(value) => onConfirm(value, 'nation')"
          @cancel="showPicker['nation'] = false"
        />
        </van-popup>
     <van-calendar v-model="showPicker['ordertime']"  
      @confirm="(value) => onConfirm(value, 'ordertime')"
      color="#1989fa"
       />
      <van-popup v-model="showPicker['obtype']" position="bottom">
        <van-picker
          show-toolbar
          :columns="ObTypeColums"
          value-key="name"
          @confirm="(value) => onConfirm(value, 'obtype')"
          @cancel="showPicker['obtype'] = false"
        />
        </van-popup>
       <van-popup v-model="showPicker['petype']" position="bottom">
        <van-picker
          show-toolbar
          :columns="BtypeColums"
          value-key="name"
          @confirm="(value) => onConfirm(value, 'petype')"
          @cancel="showPicker['petype'] = false"
        />
        </van-popup>
      <van-popup v-model="showPicker['blood']" position="bottom">
        <van-picker
          show-toolbar
          :columns="BloodColumns"
          value-key="name"
          @confirm="(value) => onConfirm(value,'blood')"
          @cancel="showPicker['blood'] = false"
        />
        </van-popup>
      <van-popup v-model="showPicker['marriage']" position="bottom">
        <van-picker
          show-toolbar
          :columns="MarriageColumns"
          value-key="name"
          @confirm="(value) => onConfirm(value, 'marriage')"
          @cancel="showPicker['marriage'] = false"
        />
      </van-popup>
      <van-popup v-model="showPicker['profession']" position="bottom">
        <van-picker
          show-toolbar
          :columns="OccupationColums"
          value-key="name"
          @confirm="(value) => onConfirm(value, 'profession')"
          @cancel="showPicker['profession'] = false"
        />
      </van-popup>
    </van-form>
    </div>
    <div class="foot">
      <van-button type="info" block class="btn_style" round @click="submit">继续</van-button>
    </div>
  </div>
</template>

<script>
// 婚姻
const MarriageColumns = [
  {
    name: "已婚",
    value: 1,
  },
  {
    name: "未婚",
    value: 2,
  },
  {
    name: "不限",
    value: 3,
  },
];
//民簇
const NationColumns = [
  { value: 1, name: "汉族" },
  { value: 2, name: "蒙古族" },
  { value: 3, name: "回族" },
  { value: 4, name: "藏族" },
  { value: 5, name: "维吾尔族" },
  { value: 6, name: "苗族" },
  { value: 7, name: "彝族" },
  { value: 8, name: "壮族" },
  { value: 9, name: "布依族" },
  { value: 10, name: "朝鲜族" },
  { value: 11, name: "满族" },
  { value: 12, name: "侗族" },
  { value: 13, name: "瑶族" },
  { value: 14, name: "白族" },
  { value: 15, name: "土家族" },
  { value: 16, name: "哈尼族" },
  { value: 17, name: "哈萨克族" },
  { value: 18, name: "傣族" },
  { value: 19, name: "黎族" },
  { value: 20, name: "傈僳族" },
  { value: 21, name: "佤族" },
  { value: 22, name: "畲族" },
  { value: 23, name: "高山族" },
  { value: 24, name: "拉祜族" },
  { value: 25, name: "水族" },
  { value: 26, name: "东乡族" },
  { value: 27, name: "纳西族" },
  { value: 28, name: "景颇族" },
  { value: 29, name: "柯尔克孜族" },
  { value: 30, name: "土族" },
  { value: 31, name: "达斡尔族" },
  { value: 32, name: "仫佬族" },
  { value: 33, name: "羌族" },
  { value: 34, name: "布朗族" },
  { value: 35, name: "撒拉族" },
  { value: 36, name: "毛难族" },
  { value: 37, name: "仡佬族" },
  { value: 38, name: "锡伯族" },
  { value: 39, name: "阿昌族" },
  { value: 40, name: "普米族" },
  { value: 41, name: "塔吉克族" },
  { value: 42, name: "怒族" },
  { value: 43, name: "乌孜别克族" },
  { value: 44, name: "俄罗斯族" },
  { value: 45, name: "鄂温克族" },
  { value: 46, name: "崩龙族" },
  { value: 47, name: "保安族" },
  { value: 48, name: "裕固族" },
  { value: 49, name: "京族" },
  { value: 50, name: "塔塔尔族" },
  { value: 51, name: "独龙族" },
  { value: 52, name: "鄂伦春族" },
  { value: 53, name: "赫哲族" },
  { value: 54, name: "门巴族" },
  { value: 55, name: "珞巴族" },
  { value: 56, name: "基诺族" },
];
//血型
const BloodColumns = [
  {
    name: "A型",
    value: 1,
  },
  {
    name: "B型",
    value: 2,
  },
  {
    name: "AB型",
    valuV: 3,
  },
  {
    name: "O型",
    value: 4,
  },
];
//学历
const EducationColums = [
  {
    name: "大学本科",
    value: "XL01",
  },
  {
    name: "高中",
    value: "XL02",
  },
  {
    name: "硕士",
    value: "XL03",
  },
  {
    name: "博士",
    value: "XL04",
  },
  {
    name: "专科",
    value: "XL05",
  },
  {
    name: "初中",
    value: "XL06",
  },
  {
    name: "小学及以下",
    value: "XL07",
  },
];
//职业
const OccupationColums = [
  {
    name: "技术人员",
    value: "ZY01",
  },
  {
    name: "农民",
    value: "ZY02",
  },
  {
    name: "机关",
    value: "ZY03",
  },
  {
    name: "公务员",
    value: "GWY",
  },
  {
    name: "教师",
    value: "JS",
  },
  {
    name: "职员",
    value: "ZY",
  },
  {
    name: "其他",
    value: "QT",
  },
];
//业务类型
const BtypeColums = [
  {
    name: "健康体检",
    value: "YWLX01",
  },
  {
    name: "招工体检",
    value: "YWLX04",
  },
  {
    name: "学生体检",
    value: "YWLX05",
  },
  {
    name: "征兵体检",
    value: "YWLX06",
  },
  {
    name: "职业体检",
    value: "YWLX02",
  },
];
//职业类型体检
const ObTypeColums = [
  {
    name: "岗前",
    value: "ZYTJ01",
  },
  {
    name: "在岗",
    value: "ZYTJ02",
  },
  {
    name: "离岗",
    value: "ZYTJ03",
  },
];
import Nav from "../../components/nav.vue";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      isobtype:true,
      showPicker: {
        nation:false,
        ordertime:false,
        profession:false,
        marriage:false,
        blood:false,
        petype:false,
        obtype:false
      },
      pickerValue: {
        nation:"",
        ordertime:"",
        petype:"",
        profession: "",
        marriage:"",
        TJLX:"个人体检",
      },
      NationColumns:NationColumns,
      BloodColumns:BloodColumns,
      OccupationColums: OccupationColums,
      MarriageColumns:MarriageColumns,
      BtypeColums:BtypeColums,
      ObTypeColums:ObTypeColums,
      form: {
        address:"",
        nation:"",
        thisAge:"",
        thisMonth:"",
        ordertime:"",
        genderId:"",
        gender:"",
        birthday:"",
        //档案号
        personalNo:"",
        name:"",
        idcard:"",
        //血型
        blood:"",
        phoneNumber:"",
        profession:"",
        marriage:"",
        TJLX:"TJLX01",
        petype:"",
        obtype:"",
      },
    };
  },
  mounted() {
    if(this.$route.query.clientId){
       this.getpelistinfo()
    }
    if(!this.form.personalNo){
       this.$router.push('/patient_card_confUser_C')
    }
  },
  methods: {
     onClickLeft(){
       this.$router.push('/index');
      },
    //根据身份证号获取年龄
    getage(idcard) {
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let age = myDate.getFullYear() - idcard.substring(6, 10) - 1;
      if (
        idcard.substring(10, 12) < month ||
        (idcard.substring(10, 12) == month &&
          idcard.substring(12, 14) <= day)
      ) {
        age++;
      }
      return age.toString();
    },
    //获取就诊卡档案信息
    getpelistinfo(){
      console.log(this.$route.query.item)
    
      this.form.address=this.$route.query.item.addProvinceName+this.$route.query.item.addCityName+this.$route.query.item.addCountyName
      this.form.thisAge=this.getage(this.$route.query.item.certificateNo)
      this.form.personalNo=this.$route.query.clientId
      this.form.phoneNumber=this.$route.query.item.phoneNumber
      this.form.idcard=this.$route.query.item.certificateNo
      this.form.birthday=this.getBirthdayFromIdCard(this.$route.query.item.certificateNo)
      this.form.thisMonth=this.getthismoth(this.form.birthday)
      this.form.genderId=this.$route.query.item.genderId
      this.form.gender=this.getgenderIDbyIdCard(this.$route.query.item.certificateNo)
      this.form.name=this.$route.query.name
    },
    //根据生日获取
   getthismoth(birthdy){
      let  Mydate = new Date().getTime()
      let Bdate = new Date(birthdy).getTime()
      let monthdate = new Date(Mydate - Bdate).getMonth()+1
      return monthdate;
   },
    //手机号验证
    certificatePhone(value) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value);
    },
    submit(){
     if(!this.form.blood){
       this.$toast.fail('暂未选择血型')
       return
     }
     if(!this.form.ordertime){
       this.$toast.fail('暂未选择预约时间')
       return
     }
      if(!this.form.marriage){
       this.$toast.fail('暂未选择婚姻状态')
       return
     }
     if(!this.form.profession){
       this.$toast.fail('暂未选择职业')
       return
     }
     if(!this.form.petype){
       this.$toast.fail('暂未选择体检类型')
       return
     }
     if(this.form.petype=="YWLX02" && !this.form.obtype){
       this.$toast.fail('暂未选择职业体检类型')
       return
     }
     this.$local.set("form", this.form);
         this.$router.push({
            path: "/pe_list_meal",
            query: {
              info:this.form
            },
        });
    },
    //选中类型
  onConfirm(item, type) {
      // console.log(type);
      // console.log(item)
      if(type=='ordertime'){
          this.form[type] = this.formatDate(item);
          this.showPicker[type] = false;
         return
      }
      if(type=='petype'){
        if(item.value=="YWLX02"){
             this.isobtype=false;
           }else{
             this.isobtype=true;
            this.pickerValue.obtype="";
           }
         this.pickerValue[type]=item.name
          this.form[type] = item.value;
          this.showPicker[type] = false;
         return
      }
      if(type=='obtype'){
         this.showPicker[type] = false;
         this.pickerValue[type]=item.name
         this.form[type] = item.value;
          return
      }
      this.pickerValue[type] = item.name;
      this.form[type] = item.name;
      this.showPicker[type] = false;
    },
    //格式化日期
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    //通过身份证号获取性别
    getgenderIDbyIdCard(idcard) {
      if (parseInt(idcard.substr(16, 1)) % 2 == 1) {
        //男
        return "男";
      } else {
        //女
        return "女";
      }
    },
    //通过身份证获取生日
    getBirthdayFromIdCard(idCard) {
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }

      return birthday;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  .nav {
    width: 100%;
    height: 50px;
  }
  .body {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    height: 100vh;
    .van-cell {
  font-size: 16px;
}
.van-cell.van-cell--large {
  padding-top: 15px;
  padding-bottom: 15px;
}
.van-field__error-message {
  font-size: 14px;
}
.van-field--disabled .van-field__label {
    color: black;
}
    .title {
      margin-left: 5px;
      font-size: 16px;
      width: 100%;
      line-height: 20px;
      color: #5b8df6;
      border-bottom: 1px dashed #f7f8fa;
    }
  }
  .foot {
    width: 100%;
    height: 45px;
    margin-bottom: 8px;
    .btn_style {
      font-size: 16px;
      letter-spacing: 5px;
      width: 90%;
      margin: 0px auto;
    }
  }
  .van-button--round {
    border-radius: 10px;
  }
}
// .last_item{
//  margin-bottom: 80px;
// }
</style>